module.exports = __webpack_public_path__ + "static/media/favorite3.07d80908.JPG";